/**
 * Exposes the custom-domain context resolved by server/middleware/customDomain.ts.
 * Seeded on the server, transferred to the client via useState payload.
 */
export function useCustomDomain() {
  const isCustomDomain = useState<boolean>('custom-domain-active', () => false)
  const customDomain = useState<string | null>('custom-domain-host', () => null)
  const customDomainUsername = useState<string | null>('custom-domain-username', () => null)

  if (import.meta.server) {
    const event = useRequestEvent()
    if (event?.context?.customDomainUsername) {
      isCustomDomain.value = true
      customDomain.value = event.context.customDomain as string
      customDomainUsername.value = event.context.customDomainUsername as string
    }
  }

  return {
    isCustomDomain: readonly(isCustomDomain),
    customDomain: readonly(customDomain),
    customDomainUsername: readonly(customDomainUsername)
  }
}
